import { useRef, useState, useEffect } from 'react';
import useAuth from '../hooks/useAuth';
import { Link, useNavigate, useLocation } from 'react-router-dom';

import axios from '../api/axios';
import { ENDPOINT_ACCOUNT_SIGN_IN } from '../Config';
import usePageTitle from '../hooks/usePageTitle';

const Login = () => {
    usePageTitle('Login');
    const { setAuth } = useAuth();

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [code, setCode] = useState('');
    const [errMsg, setErrMsg] = useState('');

    const [has2fa, setHas2fa] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        userRef.current.focus();
    }, [])

    useEffect(() => {
        setErrMsg('');
    }, [user, pwd, code])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setSubmitting(true);
            const response = await axios.post(ENDPOINT_ACCOUNT_SIGN_IN,
                JSON.stringify({
                    email: user,
                    password: pwd,
                    ...(code && { code: code })
                }),
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    withCredentials: true
                }
            );
            // console.log(JSON.stringify(response?.data));
            //console.log(JSON.stringify(response));
            const account = response?.data?.account;
            const accessToken = response?.data?.accessToken;
            setAuth({ account, accessToken });
            setUser('');
            setPwd('');
            // navigate(from, { replace: true });
            navigate("/", { replace: true });
            // window.location.reload(true);
        } catch (err) {
            if (!err?.response) {
                setErrMsg('No Server Response');
            } else if (err.response?.status === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.response?.status === 403) {
                if (has2fa) {
                    setErrMsg('Invalid verification code');
                }
                setHas2fa(true);
            } else if (err.response?.status === 401) {
                setErrMsg(err.response.data);
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        } finally {
            setSubmitting(false);
        }
    }

    return (

        <section>
            <div className="row d-flex justify-content-center">
                <div className="col-md-4">
                    <p ref={errRef} className={errMsg ? "alert alert-danger" : "offscreen"} aria-live="assertive">{errMsg}</p>
                    <h1 className='mb-5'>Sign In</h1>
                    <form onSubmit={handleSubmit}>
                        {!has2fa &&
                            <>
                                <div className="mb-3">
                                    <label htmlFor="email">Email:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="email"
                                        ref={userRef}
                                        autoComplete="off"
                                        onChange={(e) => setUser(e.target.value)}
                                        value={user}
                                        required
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password">Password:</label>
                                    <input
                                        className="form-control"
                                        type="password"
                                        id="password"
                                        onChange={(e) => setPwd(e.target.value)}
                                        value={pwd}
                                        required
                                    />
                                    <div className="form-text text-end">
                                        <Link to="/forgot-password">Forgot your password?</Link>
                                    </div>
                                </div>
                            </>
                        }
                        {has2fa &&
                            <>
                                <h4>Two-Factor Authentication</h4>
                                <div className="mb-3">
                                    <label htmlFor="code">Verification code:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        id="code"
                                        onChange={(e) => setCode(e.target.value)}
                                        placeholder='Type the verification code'
                                        value={code}
                                        required
                                    />
                                </div>
                            </>
                        }
                        <div className="text-center">
                            {has2fa &&
                                <button type='button' className="btn btn-light me-2"
                                    onClick={() => {
                                        setCode('');
                                        setHas2fa(false);
                                    }}>
                                    Cancel
                                </button>
                            }
                            <button className="btn btn-primary" disabled={submitting}>
                                {submitting && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>} Sign In
                            </button>
                        </div>
                    </form>
                    <hr />
                    <p>
                        Need an account? <Link to="/register">Sign Up</Link>
                    </p>
                </div>
            </div>

        </section>

    )
}

export default Login
